<template>
  <div class="enterSignProcess">
    <el-steps :active="active" finish-status="success" align-center>
      <el-step v-for="item of currentStepList" :key="item.id"  :title="item.title"  />
    </el-steps>
    <allComponents
      v-if="isReload"
      :active="active"
      :component="currentStepList[active].component"
      class="component"
      @cancel="cancel"
      @previousStep="previousStep"
      @confirm="confirm"
      @submit="submit"
      @continueBuild="continueBuild"
    />
  </div>
</template>
<script>
import config from './config'
import allComponents from './components'

export default {
  components: {
    allComponents,
  },
  data() {
    const { stepsList, fillStepList } = config.call(this)
    return {
      isReload: true, // 刷新页面用
      active: 0,
      stepsList,
      fillStepList,
      currentStepList: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 继续新建
    continueBuild() {
      location.href = '/car_to_lease/forRentSignContract/enterSiginProcess'
    },
    init() {
      const { stepActive } = this.$route.query
      if (stepActive) {
        this.active = Number(stepActive)
        if (Number(stepActive) > 2) {
          this.currentStepList = this.fillStepList
          return
        }
      }
      this.currentStepList = this.stepsList
    },
    // 取消
    cancel() {
      this.$confirm('是否确认退出创建企业签约提车流程?退出后已编辑的信息将不再保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refreshBack() // 关闭当前tab
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => {})
    },
    // 上一步
    previousStep() {
      this.active--
    },
    // 确认，下一步
    confirm(active) {
      if (active) { // 夸节点跳转
        this.active = active
      } else {
        this.active++
      }
    },
    // 提交
    submit() {
      this.active++
    },
  },
}
</script>
<style scoped lang='scss'>
.enterSignProcess{
  width: 100%;
  position: relative;
  margin-top: 20px;
  .component{
    margin-top: 20px;
  }
  .bottomButton{
    position: fixed;
    bottom: 16px;
    margin: 0 auto;
  }
  ::v-deep .bottom-action-inner {
    bottom: 10px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
</style>
